import RincianObservasi from 'app/KinerjaPage/pages/PelaksanaanV2/DokumenObservasi/RincianObservasi'
import { PageGuardPelaksanaan } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PageGuardPelaksanaan'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { PageGuardPelaksanaanDate } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PageGuardPelaksanaanDate'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled'] || false
    const isKinerjaPelaksanaanEnabled =
      toggle?.['kinerja-pelaksanaan-enabled'] || false

    if (!isKinerjaEnabled || !isKinerjaPelaksanaanEnabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const RincianObservasiPage = () => {
  return (
    <PageGuardPelaksanaanDate>
      <PageGuardPelaksanaan pageState="OBSERVATION_IMPLEMENTATION">
        <RincianObservasi />
      </PageGuardPelaksanaan>
    </PageGuardPelaksanaanDate>
  )
}

RincianObservasiPage.Layout = KinerjaLayout

RincianObservasiPage.layoutOpts = {
  hasHeader: true,
}

export default RincianObservasiPage
